<template lang="html">
  <section>
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <div class="bg-theme0001 bg-detail">
            <div class="position-back">
              <v-btn fab color="white" depressed @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
            </div>
            <div class="banner-detail">
              <v-img :src="detailProduct.photo_md" :aspect-ratio="1/1" alt="Banner menu" />
            </div>
            <div class="banner-detail-text">
              <div class="banner-detail-producct">
                <div class="d-flex align-center justify-space-between">
                  <div class="font-merriweather product-detail-title theme0001--text">
                    {{ typeof detailProduct.alt_name === 'undefined' || detailProduct.alt_name === '' ? detailProduct.name : detailProduct.name + ' / ' + detailProduct.alt_name }}
                  </div>
                  <v-btn fab color="white" x-small depressed class="btn-share" @click="goShare()">
                    <v-icon>
                      mdi-share-variant-outline
                    </v-icon>
                  </v-btn>
                </div>
                <template v-if="$store.state.selected_store.setting.show_price_book_menu">
                  <div v-mask-money="detailProduct.sell_price_pos" class="font-merriweather product-detail-subtitle" />
                </template>
              </div>
            </div>
            <v-container fluid class="px-6">
              <v-row>
                <v-col v-if="detailProduct.description" cols="12">
                  <div class="font-merriweather detail-desc white--text">
                    {{ detailProduct.description }}
                  </div>
                </v-col>
                <v-col v-if="detailProduct.variants && detailProduct.variants.length > 0" cols="12">
                  <div class="title--line">
                    {{ detailProduct.variant_label }}
                  </div>
                  <div class="font-merriweather container-variant">
                    <div v-for="(item, idx) in detailProduct.variants" :key="idx" class="list-variant">
                      <div class="theme0001--text">
                        {{ item.alt_name === '' ? item.name : item.name + ' / ' + item.alt_name }}
                      </div>
                      <div v-if="$store.state.selected_store.setting.show_price_book_menu" v-mask-money="item.sell_price_pos" />
                    </div>
                  </div>
                </v-col>
                <v-col v-if="detailProduct.items && detailProduct.items.length > 0" cols="12">
                  <div class="title--line">
                    Item
                  </div>
                  <div class="font-merriweather container-variant">
                    <div v-for="(item, idx) in detailProduct.items" :key="idx" class="list-variant">
                      <div class="theme0001--text">
                        {{ item.product_variant_name && item.product_variant_name !== '' ? item.product_name + ' (' + item.product_variant_name + ')' : item.product_name }}
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <div class="d-relative">
              <div class="powered-detail">
                <v-divider dark />
                <div class="d-flex align-center justify-center py-4">
                  <a href="https://bit.ly/3rU2JQ2" target="_blank">
                    <img src="@/assets/images/dark_powered-by-olsera.svg" alt="Powered by Olsera" class="img-powered">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbarCopy.show" top>
      {{ snackbarCopy.text }}
    </v-snackbar>
  </section>
</template>

<script>
export default {
  props: {
    detailProduct: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      snackbarCopy: {
        show: false,
        text: ''
      }
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'list_menu' }).catch(e => {})
    },
    goShare() {
      const link_url = window.location.href
      const _this = this
      this.$copyText(link_url).then(function(e) {
        _this.snackbarCopy.show = true
        _this.snackbarCopy.text = 'Link copied successfully'
      }, function(e) {
        _this.snackbarCopy.show = true
        _this.snackbarCopy.text = 'Oops, unable to copy'
      })
    }
  }
}
</script>

<style lang="css" scoped>
  .theme0001--text{
    color: #F8E008;
  }
  .bg-detail{
    min-height: 100vh;
    position: relative;
    margin: 0 12px;
  }
  .bg-theme0001{
    background-color: #232323 !important;
  }
  .banner-detail{
    display: flex;
    flex: 1 1 auto;
  }
  .position-back {
    position: absolute;
    top: 24px;
    left: 16px;
    z-index: 2;
  }
  .banner-detail-text{
    background-color: #232323;
    position: relative;
    z-index: 0;
    overflow-x: clip;
    padding: 0px 24px;
    color: #fff;
  }
  .banner-detail-text:after {
    background: #232323 0% 0% no-repeat padding-box;
    opacity: 1;
    filter: blur(29px);
    content: "";
    position: absolute;
    top: -100px;
    bottom: 0px;
    left: -60px;
    right: -60px;
  }
  .banner-detail-producct{
    color: #fff;
    position: relative;
    z-index: 1;
  }
  .product-detail-title{
    font-size: 26px;
  }
  .product-detail-subtitle{
    font-size: 18px;
  }
  .title--line {
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
    color: #fff;
    font-size: 20px;
    text-transform: capitalize;
    font-family: 'Dancing Script', cursive;
  }
  .title--line:after {
    content: "";
    height: 100%;
    vertical-align: bottom;
    width: 100%;
    margin-right: -100%;
    margin-left: 10px;
    border-top: 1px solid #fff;
  }
  .detail-desc{
    font-size: 12px;
  }
  .container-variant{
    padding: 8px 0;
  }
  .list-variant {
    display: flex;
    justify-content: space-between;
    color: #fff;
    font-size: 14px;
    padding: 4px 0;
  }
  .powered-detail {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .btn-share{
    position: absolute;
    top: -56px;
    right: 0px;
  }
  .powered-detail a {
    line-height: normal;
  }
  @media (min-width: 600px) {
    .powered-detail {
      margin-right: 25%;
      margin-left: 25%;
    }
  }
  @media (min-width: 960px) {
    .powered-detail {
      margin-right: 33.3333333333%;
      margin-left: 33.3333333333%;
    }
  }
</style>
